import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import {
  getClassifiersCountriesList,
  getClassifiersCountriesListData,
  getClassifiersCountriesDelete,
} from '../../reducers/classifiersReducer';
import {
  showCountriesEditModal,
  hideCountriesEditModal,
  getCountriesEditModal,
} from '../../actions/actionCreators/modalsActionCreators';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { Spin, Modal, Button } from 'antd';
import * as actions from '../../actions/actionCreators/classifiersActionCreators';
import { CountriesTable, TableActions } from '../../components';
import { CountriesEdit as CountriesEditForm } from '../../forms';
import { goToClassifiers } from '../../utils/gotoLink';

const CountriesList = ({
  t,
  loading,
  fetchClassifier,
  deleteClassifier,
  classifierData,
  modalVisible,
  hideModal,
  showModal,
}) => {
  const selectedCodeRef = useRef(null);

  useEffect(() => {
    fetchClassifier();
  }, [fetchClassifier]);

  const handleShowModal = (code = null) => {
    selectedCodeRef.current = code;
    showModal();
  };

  return (
    <Spin spinning={loading}>
      <h1>{t('countries.title')}</h1>
      {classifierData && (
        <CountriesTable
          t={t}
          dataSource={classifierData.toJS()}
          deleteClassifier={deleteClassifier}
          showModal={handleShowModal}
        />
      )}
      {modalVisible && (
        <Modal
          title={t('modalCountriesTitle')}
          open
          footer={null}
          onCancel={hideModal}
          width={640}
        >
          <CountriesEditForm
            onCancel={hideModal}
            onComplete={hideModal}
            operatorCode={selectedCodeRef.current}
            t={t}
          />
        </Modal>
      )}
      <TableActions>
        <Button onClick={goToClassifiers}>{t('buttonBack')}</Button>
        <Button
          type="primary"
          onClick={() => handleShowModal(null)}
          className="global-margin-left-10"
        >
          {t('buttonValueAdd')}
        </Button>
      </TableActions>
    </Spin>
  );
};

CountriesList.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchClassifier: PropTypes.func.isRequired,
  deleteClassifier: PropTypes.func.isRequired,
  classifierData: PropTypesImmutable.list,
  modalVisible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
};

const getIsLoading = getLoadingSelector(
  getClassifiersCountriesList,
  getClassifiersCountriesDelete
);

const mapStateToProps = (state) => ({
  loading: getIsLoading(state),
  classifierData: getClassifiersCountriesListData(state),
  modalVisible: getCountriesEditModal(state),
});

const mapDispatchToProps = (dispatch) => ({
  fetchClassifier: () => {
    dispatch(actions.fetchClassifierCountriesList());
  },
  deleteClassifier: async (code) => {
    await dispatch(actions.deleteClassifierCountries(code));
    dispatch(actions.fetchClassifierCountriesList());
  },
  showModal: () => {
    dispatch(showCountriesEditModal());
  },
  hideModal: () => {
    dispatch(hideCountriesEditModal());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CountriesList);
